import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'wrapListHtml', pure: false })
export class WrapListHtmlPipe implements PipeTransform {
  constructor() {}

  transform(content: string) {
    if (!content) return '';

    // Gom các khối <li> liên tiếp lại thành 1 khối duy nhất
    const groupedList = content.replace(
      /((?:<li>.*?<\/li>\s*){2,})/gs,
      match => `<ul>${match}</ul>`
    );

    return groupedList
  }
}
